import iconWarning from '../../assets/icon/icon-warning.svg';
import iconChevronUp from '../../assets/icon/icon_chevron_up.svg';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import LogoList from '../../components/logoList';

const HasilAnalisaBerhasil = (props) => {
  const { analisa } = props;
  const navigate = useNavigate();

  const [showDetail, setShowDetail] = useState(true);
  const [showProduct, setShowProduct] = useState(false);

  function cekWarna(persen, opacity = 100) {
    let nilai = parseFloat(persen.replace('%', ''));
    let opacityValue = opacity / 100;
    let warna = '';

    if (nilai >= 0 && nilai <= 30) {
      warna = '#2EBA37';
    } else if (nilai > 30 && nilai < 50) {
      warna = '#E89227';
    } else if (nilai >= 50 && nilai <= 100) {
      warna = '#E6232B';
    } else {
      warna = '#E6232B';
    }

    return hexToRgba(warna, opacityValue);
  }

  function hexToRgba(hex, opacity) {
    let c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    let r = parseInt(c[0] + c[1], 16);
    let g = parseInt(c[2] + c[3], 16);
    let b = parseInt(c[4] + c[5], 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  return (
    <div className="flex-grow flex flex-col justify-start items-center w-full my-5 md:my-14 md:px-10">
      <div className=" grid md:grid-cols-5 gap-5 md:gap-10 mb-5">
        <div className="md:col-span-2">
          <img
            src={analisa?.image_url}
            className="w-full object-contain rounded-xl"
            alt="hasil analisa"
          />
          <div className="shadow-md p-4 mt-5 bg-white rounded-xl">
            <div
              onClick={() => setShowDetail(!showDetail)}
              className="cursor-pointer flex justify-between items-center">
              <div className="flex justify-start items-center space-x-2">
                <img
                  src={iconWarning}
                  className="w-6 h-6 object-contain"
                  alt=""
                />
                <h3 className="font-medium text-xl text-textBlack">
                  {analisa?.skinive?.disease_name_general}
                </h3>
              </div>
              <img
                src={iconChevronUp}
                className={`${
                  showDetail ? 'rotate-0' : 'rotate-180'
                } transition-transform w-6 h-6 object-contain`}
                alt=""
              />
            </div>

            {showDetail && (
              <div className="my-3">
                <hr />
              </div>
            )}

            <div
              className={`${
                showDetail ? 'h-auto' : 'h-0'
              } transition-all overflow-hidden`}>
              <h4 className="text-sm text-textGray font-bold">Penjelasan</h4>
              <p className="text-sm text-textGray mt-1">
                {parse(analisa?.skinive?.description ?? '')}
              </p>
            </div>
          </div>

          {/* {analisa?.topn?.length > 0 && (
            <>
              {analisa?.topn?.map((item, key) => {
                return (
                  <div className="flex space-x-4 justify-center items-center shadow-md p-4 mt-2 bg-white rounded-xl">
                    <div
                      className="flex text-sm flex-none font-semibold justify-center items-center w-16 h-16 p-2 rounded-full"
                      style={{ backgroundColor: cekWarna(item?.prob, 25) }}>
                      <span style={{ color: cekWarna(item?.prob) }}>
                        {item?.prob}
                      </span>
                    </div>
                    <div className="w-full flex flex-col justify-center items-start h-full">
                      <h3 className="font-medium text-xl text-textBlack">
                        {item?.class}
                      </h3>
                      <p className=" text-textBlack mt-1">
                        {item?.desease}
                      </p>
                    </div>
                  </div>
                );
              })}
            </>
          )} */}

          {analisa?.topn?.length > 0 && (
            <div className="flex space-x-4 justify-center items-center shadow-md p-4 mt-2 bg-white rounded-xl">
              <div
                className="flex text-sm flex-none font-semibold justify-center items-center w-16 h-16 p-2 rounded-full"
                style={{
                  backgroundColor: cekWarna(analisa?.topn[0]?.prob, 25)
                }}>
                <span style={{ color: cekWarna(analisa?.topn[0]?.prob) }}>
                  {analisa?.topn[0]?.prob}
                </span>
              </div>
              <div className="w-full flex flex-col justify-center items-start h-full">
                {/* <h3 className="font-medium text-xl text-textBlack">
                        {item?.class}
                      </h3> */}
                <p className=" text-textBlack mt-1">
                  {analisa?.topn[0]?.desease}
                </p>
              </div>
            </div>
          )}
        </div>
        <div className="md:col-span-3">
          {analisa?.products?.length > 0 && (
            <>
              {analisa?.products?.map((item, key) => {
                return (
                  <div className="w-full mb-4">
                    <div className="shadow-md p-4 bg-white rounded-xl">
                      {key === 0 && (
                        <>
                          <div className="cursor-pointer flex justify-between items-center">
                            <div className="flex justify-start items-center space-x-2">
                              <h3 className="font-medium text-xl text-red">
                                Rekomendasi Produk
                              </h3>
                            </div>
                          </div>

                          <div className="my-3 border-b border-red"></div>
                        </>
                      )}

                      <div>
                        <h1 className="font-semibold text-textBlack text-xl">
                          {item?.name}
                        </h1>
                        <div className="flex justify-center items-center ">
                          <img
                            src={item.image_url}
                            className=" w-full object-contain rounded-xl px-10 max-w-[350px] object-center"
                            alt="hasil analisa"
                          />
                        </div>

                        <div className="mt-5 bg-white rounded-xl">
                          <div
                            onClick={() => setShowProduct(!showProduct)}
                            className="cursor-pointer flex justify-between items-center">
                            <div className="flex justify-start items-center space-x-2">
                              <img
                                src={iconWarning}
                                className="w-6 h-6 object-contain"
                                alt=""
                              />
                              <h3 className="font-medium text-xl text-textBlack">
                                Info Produk
                              </h3>
                            </div>
                            <img
                              src={iconChevronUp}
                              className={`${
                                showProduct ? 'rotate-0' : 'rotate-180'
                              } transition-transform w-6 h-6 object-contain`}
                              alt=""
                            />
                          </div>

                          {showProduct && (
                            <div className="my-3">
                              <hr />
                            </div>
                          )}

                          <div
                            className={`${
                              showProduct ? 'h-auto' : 'h-0'
                            } transition-all overflow-hidden`}>
                            <div className="bg-darkerCream p-5 rounded-2xl mb-5">
                              <div className="text-textBlack font-semibold text-xl mb-2">
                                Deskripsi
                              </div>
                              <div className='text-justify'>
                              {parse(item?.short_description ?? '')}
                              </div>

                            </div>
                            <div>{parse(item?.description ?? '')}</div>
                          </div>
                        </div>

                        {key === analisa?.products?.length - 1 && (
                          <>
                            <div className="my-3">
                              <hr />
                            </div>

                            <LogoList />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
      <div className=" flex flex-none md:max-w-[450px] text-textGray text-xs md:text-sm md:mt-10">
        <span className="mr-2">Note:</span>
        <p>
          Hasil analisa ini adalah sebagai pendeteksi awal, untuk pemeriksaan
          lebih detail silahkan periksa ke dokter kulit
        </p>
      </div>
    </div>
  );
};

export default HasilAnalisaBerhasil;
